import {
  MenuBills,
  MenuBillsFilled,
  MenuCockpit,
  MenuCockpitFilled,
  MenuMySubscriptions,
  MenuMySubscriptionsFilled,
  MenuPartner,
  MenuPartnerFilled,
  MenuUser,
  MenuUserFilled,
} from "@/assets/icons/icons";
import { useCustomerTribe } from "@/hooks/useCustomerTribe";
import { portalRoutes } from "@/router/routes/portalRoutes";
import { useGetCustomer } from "@/services/api";

export const navigationItems = [
  {
    icon: <MenuCockpit />,
    activeIcon: <MenuCockpitFilled />,
    text: "layout.menu.items.cockpit",
    target: portalRoutes.cockpit.base,
  },
  {
    icon: <MenuMySubscriptions />,
    activeIcon: <MenuMySubscriptionsFilled />,
    text: "layout.menu.items.mySubscriptions",
    target: portalRoutes.mySubscriptions.base,
  },
  {
    icon: <MenuBills />,
    activeIcon: <MenuBillsFilled />,
    text: "layout.menu.items.documents",
    ariaLabel: "layout.menu.items.documentsAriaLabel",
    target: portalRoutes.documents.base,
  },
  {
    icon: <MenuPartner />,
    activeIcon: <MenuPartnerFilled />,
    text: "layout.menu.items.friendsWithBenefits",
    bottomNavText: "layout.menu.items.friendsWithBenefitsShort",
    target: portalRoutes.friendsWithBenefits.base,
  },
  {
    icon: <MenuUser />,
    activeIcon: <MenuUserFilled />,
    text: "layout.menu.items.account",
    ariaLabel: "layout.menu.items.accountAriaLabel",
    target: portalRoutes.user.base,
  },
] as const;

type CustomerShellQueryOptions = {
  enabled?: boolean;
};

/**
 * Private customers only: friends-with-benefits is hidden entirely for
 * other customer types, matching the existing BottomNavBar filter.
 */
export const useVisibleNavigationItems = ({
  enabled = true,
}: CustomerShellQueryOptions = {}) => {
  const { data: customer } = useGetCustomer(undefined, {
    query: { enabled },
  });
  const isPrivateCustomer = customer?.customerType?.id === 1;

  if (!enabled) {
    return navigationItems;
  }

  return navigationItems.filter(
    (item) =>
      !(
        item.target === portalRoutes.friendsWithBenefits.base &&
        !isPrivateCustomer
      ),
  );
};

export const useShowFriendsWithBenefitsAttentionBubble = ({
  enabled = true,
}: CustomerShellQueryOptions = {}) => {
  const { data: customerTribe } = useCustomerTribe({ enabled });

  if (!enabled) {
    return false;
  }

  return !(
    // If data is saved for 'showFriendsWithBenefitsHint' it means user already viewed the friendsWithBenefits page before (during this login-session)
    (
      !!sessionStorage.getItem("showFriendsWithBenefitsHint") ||
      !!customerTribe?.tribeId
    )
  );
};
